// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1H2mQ","label":"Radio_label__213NM","checkMark":"Radio_checkMark__OMg7N","disabled":"Radio_disabled__1cD9b"};